<template>
    <rkm-overlay>
        <rkm-layout-body title="Nova internação">
            <template v-slot:actions>
                <rkm-button
                    @click="exit(redirectToList)"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.nome }} <strong>({{ paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.nome }},
                    </span>
                    <span v-if="paciente.idade">
                        {{ paciente.idade.anos }} anos,
                        {{ paciente.idade.meses }} meses
                        e {{ paciente.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    @save="exit(redirectToList, false)"
                    :additionals="additionals"
                    :form="form"
                    :model="model"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/pronto-atendimento/aih/Form'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

import { viewForm, form, repository, request, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            aih: this.getConectaSusRepository('prontoAtendimento.aih')
        }

        this.init()
    },
    data: () => ({
        paciente: null,
        enums: { preferenciaNome }
    }),
    methods: {
        init() {

            const request = this.id
                ? this.fetch(this.repositories.aih.edit, this.id)
                : this.fetch(this.repositories.aih.create, this.pacienteId)

            const responseInterceptor = ({ data }) => {

                if (data.model.procedimento.dataSolicitacao) {

                    data.model.procedimento.dataSolicitacao = this.getDateObject(
                        data.model.procedimento.dataSolicitacao
                    )
                }

                if (data.model.autorizacao.dataAutorizacao) {

                    data.model.autorizacao.dataAutorizacao = this.getDateObject(
                        data.model.autorizacao.dataAutorizacao
                    )
                }

                if (data.form.paciente.identificacao) {
                    this.paciente = data.form.paciente.identificacao
                    this.paciente.nome = data.form.paciente.identificacao.nomePaciente
                }
            }

            this.load(request, responseInterceptor)
        },
        redirectToList() {

            this.$router.push({ name: 'pronto-atendimento-aih-index' }).catch(() => {})
        },
    },
    mixins: [viewForm, form, repository, request, data],
    props: {
        id: { type: Number },
        pacienteId: { type: Number }
    }
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>